import { render, staticRenderFns } from "./SliceTopics.vue?vue&type=template&id=08baeea2&lang=pug&"
import script from "./SliceTopics.vue?vue&type=script&lang=js&"
export * from "./SliceTopics.vue?vue&type=script&lang=js&"
import style0 from "./SliceTopics.vue?vue&type=style&index=0&id=08baeea2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports